'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const LoginModalConfig=require('../../../../dist-es6/client/features/login/modals/loginModalConfig');
const BaseOrganizationProfileController=require('../../../../dist-es6/client/features/organizationProfile/baseOrganizationProfileController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const OrganizationProfileData=require('../../../../dist-es6/client/dtos/organizationProfileData');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');let

OrganizationUsersController=function(_BaseOrganizationProf){_inherits(OrganizationUsersController,_BaseOrganizationProf);_createClass(OrganizationUsersController,null,[{key:'$inject',get:function()
{
return['$scope','$modal','breadcrumbsService','$state','$timeout','userService','socketService','uncaughtErrorHandler'];
}}]);

function OrganizationUsersController($scope,$modal,breadcrumbsService,$state,$timeout,userService,socketService,uncaughtErrorHandler){_classCallCheck(this,OrganizationUsersController);var _this=_possibleConstructorReturn(this,
_BaseOrganizationProf.call(this,$state,$timeout,userService,socketService,uncaughtErrorHandler));

breadcrumbsService.startTrail('User Access');

_this._$modal=$modal;

_this._columnDefinitions=[{
label:'Name',
defaultAscending:!0,
orderBy:['firstName','lastName'],
columnClass:'name-column'},
{
label:'Permissions',
defaultAscending:!0,
isInitiallyActive:!0,
orderBy:['role'],
finalSort:['-isPrimary','firstName','lastName'],
columnClass:'permissions-column'}];


$scope.$watch('controller.profileData',function(){
if(!_.exists(_this,'profileData.users')){
return;
}

_this.profileData.users.forEach(function(user){
user.editUser=function(){return _this.editUser(user)};
});
});return _this;
}OrganizationUsersController.prototype.



createUser=function createUser(){var _this2=this;
let createUserModal=this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/createUserModalView',
controller:'CreateUserModalController as controller',
windowClass:'create-user',
resolve:{
onUserCreated:function(){return _this2._reloadProfileData.bind(_this2)}}});


createUserModal.result.then(function(user){
_this2._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/userCreatedModalView',
controller:'UserCreatedModalController as controller',
windowClass:'user-created',
resolve:{
user:function(){return user}}});


});
};OrganizationUsersController.prototype.

editUser=function editUser(user){var _this3=this;
let editUserModal=this._$modal.open({
templateUrl:'/templates/features/organizationUsers/components/editOrganizationUserModalView',
controller:'EditOrganizationUserModalController as controller',
windowClass:'edit-user',
resolve:{
user:function(){return user},
onUserUpdated:function(){return _this3._reloadProfileData.bind(_this3)}}});


};_createClass(OrganizationUsersController,[{key:'columnDefinitions',get:function(){return this._columnDefinitions}}]);return OrganizationUsersController}(BaseOrganizationProfileController);


module.exports=OrganizationUsersController;
//# sourceMappingURL=organizationUsersController.js.map
